export default __webpack_public_path__ + "static/media/left_connect.50a7c0d8.svg";